export default "__VITE_ASSET__fb0d71bd__"